export const convertToPersianNumber = (input) => {
    if (typeof input !== 'string') {
        input = input.toString();
    }

    const persianDigits = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];

    return input.replace(/\d/g, (digit) => persianDigits[+digit]);
};
